const Spinner = () => {
    return (
        <div className="spinner-h">
            <img src={`${window.env.SITE_DOMAIN}/Media/Image/company_loader.svg`} alt="loader"/>
        </div>
    )
}

export default Spinner;